var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.note && _vm.note.length > 0)?_c('p',{staticClass:"food-note",style:({ 'color': _vm.config.ColorContent,
    'font-size': (((_vm.config.FontSizeContent - 5)) + "px"),
    'font-family': _vm.config.FontContent, 
  })},[_vm._v(" "+_vm._s(_vm.note)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }